.betslipContainer {
  display: flex;
  position: fixed;
  background: var(--ogm-white);
  box-shadow:
    0 4px 10px 0 rgba(0, 0, 0, 0.16),
    0 4px 10px 0 rgba(0, 0, 0, 0.23);
  flex-direction: column;
  height: 100%;
  max-width: 500px;
  margin: 0 auto;
  right: 0;
  width: 360px;
  z-index: var(--cxy-z-index-modal-wrapper);
  transform: translateX(100%) scaleX(0);
}
@media (max-width: 767px) {
  .betslipContainer {
    width: 100%;
    max-width: unset;
    transform: translateX(0) translateY(150%);
  }
}
.betslipContainer.open {
  transition:
    all 0.3s ease-in,
    top 0s;
  transform: translateX(0%) scaleX(1);
}
@media (max-width: 767px) {
  .betslipContainer.open {
    transform: translateX(0) translateY(0);
  }
}
@media (min-width: 1024px) {
  .betslipContainer.increasedWidth {
    max-width: 500px;
    min-width: 500px;
    width: 500px;
  }
}
.betslipContainer .header {
  display: flex;
  align-items: center;
  background: repeating-linear-gradient(
    45deg,
    var(--ogm-timberwolves),
    var(--ogm-timberwolves) 5px,
    var(--ogm-pelicans) 1px,
    var(--ogm-pelicans) 6px
  );
  color: var(--ogm-white);
  justify-content: space-between;
  height: 44px;
  min-height: 44px;
  padding: 5px 10px;
  box-sizing: content-box;
}
.betslipContainer .header .content {
  display: flex;
  align-items: center;
  box-sizing: inherit;
}
.betslipContainer .header .closeIcon {
  cursor: pointer;
  display: flex;
}
.betslipContainer .header .counter {
  font-family: var(--ogm-font-family-2);
  font-weight: 500;
  font-size: 1.2rem;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: unset;
  background: var(--ogm-seahawks);
  border-radius: 50%;
  color: var(--ogm-black);
  line-height: unset;
  margin-right: 5px;
  min-height: 20px;
  min-width: 20px;
  padding: 2px;
  text-align: center;
  font-family: var(--ogm-font-family-2);
  box-sizing: inherit;
}
.betslipContainer .header .title {
  padding-right: 15px;
  display: flex;
  justify-content: center;
  text-align: center;
  width: 100%;
  font-family: var(--ogm-font-family-1);
  font-size: 24px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: 0.5px;
}
@media (max-width: 767px) {
  .betslipContainer .header .title {
    font-size: 16px;
  }
}
.betslipContainer .header button {
  width: 100px;
  padding: 5px 8px;
  margin: 0 10px 0 0;
  border-radius: 30px;
  background-color: var(--ogm-pelicans);
  font-family: var(--ogm-font-family-1);
  border: none;
  color: var(--ogm-white);
  font-size: 13px;
  text-transform: uppercase;
}
.betslipContainer .header button:hover {
  background-color: #38465f;
}
.betslipContainer .header button svg {
  margin-right: 4px;
}
.betslipContainer .emptyBetslip {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  width: 100%;
}
.betslipContainer .emptyBetslip .title {
  font-family: var(--ogm-font-family-1);
  font-size: 24px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: 0.5px;
  margin-top: 0;
  margin-bottom: 0;
  padding: 16px 0 8px 0;
}
.betslipContainer .emptyBetslip .loadingIconWrapper {
  height: 210px;
  margin-bottom: 15px;
  width: 210px;
  margin-right: 60px;
}
.betslipContainer .emptyBetslip .loadingIconWrapper span {
  position: absolute;
}
.betslipContainer .emptyBetslip .iconWrapper {
  height: 210px;
  margin-bottom: 15px;
  width: 210px;
}
.betslipContainer .emptyBetslip .iconWrapper span {
  position: absolute;
}
.betslipContainer .emptyBetslip .info {
  max-width: 70%;
  text-align: center;
  font-family: var(--ogm-font-family-2);
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
}
.betslipContainer .emptyBetslip .dost1 {
  fill: #ffd7cc;
}
.betslipContainer .emptyBetslip .dost2 {
  fill: #20242e;
}
.betslipContainer .emptyBetslip .dost4 {
  fill: #efc4bd;
}
.betslipContainer .emptyBetslip .dost6 {
  fill: #111f59;
}
.betslipContainer .loadingBetslip .fmst0 {
  opacity: 0.2;
  fill: #20242e;
}
.betslipContainer .loadingBetslip .fmst1 {
  fill: #efc4bd;
}
.betslipContainer .loadingBetslip .fmst2 {
  fill: #20242e;
}
.betslipContainer .loadingBetslip .fmst3 {
  fill: #1ed560;
}
.betslipContainer .loadingBetslip .fmst4 {
  fill: #ffd7cc;
}
.betslipContainer .loadingBetslip .fmst5 {
  fill: #303644;
}
.betslipContainer .loadingBetslip .fmst6 {
  fill: #052643;
}
.betslipContainer .loadingBetslip .fmst7 {
  fill: #20242e;
}
.betslipContainer .loadingBetslip .fmst7,
.betslipContainer .loadingBetslip .fmst8,
.betslipContainer .loadingBetslip .fmst9 {
  opacity: 0.5;
}
.betslipContainer .loadingBetslip .fmst9 {
  fill: #303644;
}
.betslipContainer .singleButtonSection {
  bottom: 0;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
}
.betslipContainer .singleButtonSection .singleButton {
  font-family: var(--ogm-font-family-2);
  font-weight: 500;
  font-size: 1.2rem;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  background: var(--ogm-seahawks);
  border-radius: 3px;
  color: var(--ogm-timberwolves);
  height: 44px;
  justify-content: center;
  min-width: 100%;
  width: 100%;
  z-index: var(--cxy-z-index-control-highest);
}
.betslipContainer .singleButtonSection .singleButton:hover {
  background-color: #03cb8f;
}
.betslipContainer .buttonSection {
  font-family: var(--ogm-font-family-2);
  font-weight: 500;
  font-size: 1.2rem;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
  display: grid;
  align-items: center;
  justify-content: center;
  grid-template-columns: repeat(2, 1fr);
  border-top: 1px solid #ddd;
  height: 64px;
  width: 100%;
  background-color: var(--ogm-white);
  position: fixed;
  bottom: 0;
  z-index: var(--cxy-z-index-control-highest);
}
.betslipContainer .buttonSection .button {
  font-family: var(--ogm-font-family-2);
  font-weight: 500;
  font-size: 1.2rem;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
  height: 44px;
  justify-self: center;
  width: 95%;
  font-size: 13px;
  white-space: nowrap;
}
.betslipContainer .buttonSection .button svg {
  margin-right: 4px;
}
@media (max-width: 767px) {
  .betslipContainer .buttonSection {
    grid-template-columns: 1fr 7fr;
    padding-left: 4px;
  }
}
.betslipContainer .loadingView {
  height: 100%;
  padding: 10px;
}
.betslipContainer .tabsWrapper {
  height: 100%;
  margin-bottom: 50px;
  overflow-y: scroll;
}

[data-fpsm-theme='gazzetta'] {
  .betslipContainer {
    background: var(--cxy-color-container-default);
    z-index: var(--cxy-z-index-auth-modal); /* Above the overlay (9998) */
    height: calc(var(--parent-window-height, 100%) - var(--parent-header-height));
    top: var(--parent-window-top-offset, 0px);
  }

  .betslipContainer .header {
    display: flex;
    align-items: center;
    background: var(--cxy-color-black);
    color: var(--cxy-color-content-dark);
    justify-content: space-between;
    height: 44px;
    min-height: 44px;
    padding: 5px 10px;
    box-sizing: content-box;
  }

  .betslipContainer .buttonSection {
    border-top: 1px solid #aaa;
    background-color: var(--cxy-color-container-default);
  }

  .betslipContainer .header .counter {
    color: var(--cxy-color-black);
    border-radius: 50%;
    background: var(--cxy-color-white);
    font-family: var(--ogm-font-family-2);
  }

  .betslipContainer .buttonSection .button {
    background: #ccc;
  }

  .betslipContainer .buttonSection .button:nth-child(2),
  .betslipContainer .singleButtonSection .singleButton {
    background: var(--cxy-color-black);
    color: var(--cxy-color-content-dark);
  }

  @media (max-width: 767px) {
    .betslipContainer {
      transform: translateX(100%) scaleX(0);
      &.open {
        transform: translateX(0) scaleX(1);
      }
    }
  }
}
